import { Phone, MessageCircle } from "lucide-react";

export const FloatingContact = () => {
  const phone = "+918466864527";
  const whatsappMsg = encodeURIComponent(
    "Hi BIOMAC, I'm interested in the 45-day medical devices course. Please share the details."
  );
  return (
    <div
      className="fixed bottom-5 right-5 z-40 flex flex-col gap-3 lg:bottom-8 lg:right-8"
      data-testid="floating-contact"
    >
      <a
        href={`https://wa.me/${phone.replace("+", "")}?text=${whatsappMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform flex items-center justify-center"
      >
        <MessageCircle size={26} strokeWidth={2.2} fill="currentColor" />
      </a>
      <a
        href={`tel:${phone}`}
        data-testid="floating-call"
        aria-label="Call"
        className="w-14 h-14 rounded-full bg-[#0A3B32] text-white shadow-lg hover:scale-105 transition-transform flex items-center justify-center animate-pulse"
      >
        <Phone size={22} strokeWidth={2.2} />
      </a>
    </div>
  );
};
